import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AppSettings } from "../../../app.settings";
import { DisclosureAcceptance } from "../domain/models/agreement-disclosure.model";

interface DisclosureAcceptedResponse {
  accepted: boolean;
  dateUtc: string;
}

/** Disclosure acceptance on the in-house signing path; each acceptance is kept in the customer's disclosure history. */
@Injectable({
  providedIn: "root",
})
export class AgreementDisclosureRemote {
  private readonly baseUrl: string;

  constructor(
    private readonly http: HttpClient,
    private readonly settings: AppSettings
  ) {
    this.baseUrl = `${this.settings.customers.url}/api/checkout/disclosure`;
  }

  acceptDisclosure(code: string): Observable<DisclosureAcceptance> {
    return this.http
      // hideLoader: the disclosure shows its own inline spinner, so the page blocker stays away.
      .put<DisclosureAcceptedResponse>(
        `${this.baseUrl}/${encodeURIComponent(code)}`,
        { accepted: true },
        { headers: new HttpHeaders().set("hideLoader", "true") }
      )
      .pipe(map((response) => this.toAcceptance(response)));
  }

  private toAcceptance(response: DisclosureAcceptedResponse): DisclosureAcceptance {
    if (!response.accepted) {
      throw new Error("This disclosure could not be accepted. Please contact us.");
    }

    return { acceptedOnUtc: new Date(response.dateUtc) };
  }
}
